module.exports = __webpack_public_path__ + "img/engravingSymbol.caa4eba.webp";